import React, { useState } from 'react'
import { ModalBody, ModalFooter } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import ErrorBoundary from '@/components/ErrorBoundary'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import { SelectInstitutionButton } from '@/report-app/pages/institution/selectButton'
import { InstitutionDropdown } from '@/report-app/pages/institution/institutionDropdown'

function InstitutionSelectionDialog (props) {
  const { closeDialog } = props
  const [institution, setInstitution] = useState(null)

  return (
    <React.Fragment>
      <BasicHeader title='Institutions.SelectOneTitle' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <p><Resx name='Institutions.SelectOneText' /></p>
          <InstitutionDropdown value={institution} onChange={setInstitution} />
        </ErrorBoundary>
      </ModalBody>
      <ModalFooter>
        <SelectInstitutionButton institution={institution} onChange={() => closeDialog()} />
        <Button onClick={() => closeDialog()}>
          <Resx name='Common.Cancel' />
        </Button>
      </ModalFooter>
    </React.Fragment>
  )
}

export default {
  component: InstitutionSelectionDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/institutionSelection.js